export enum GoogleAnalyticsReportRequestTypeEnum {
    COVERAGE_IMPACT_TREND = 'COVERAGE_IMPACT_TREND',
    REFERRAL_TREND = 'REFERRAL_TREND',
    TOP_SOCIAL_REFERRERS_USERS = 'TOP_SOCIAL_REFERRERS_USERS',
    TOP_SOCIAL_REFERRERS_SESSIONS = 'TOP_SOCIAL_REFERRERS_SESSIONS',
    TOP_REFERRAL_SOURCES_USERS = 'TOP_REFERRAL_SOURCES_USERS',
    TOP_REFERRAL_SOURCES_SESSIONS = 'TOP_REFERRAL_SOURCES_SESSIONS',
    TOP_REFERRAL_SOURCES_NEW_RETURNING_SESSIONS = 'TOP_REFERRAL_SOURCES_NEW_RETURNING_SESSIONS',
    TOP_REFERRAL_SOURCES_NEW_RETURNING_USERS = 'TOP_REFERRAL_SOURCES_NEW_RETURNING_USERS',
}
